module.exports = __webpack_public_path__ + "img/menu-bg.c1d9b3c1.png";